import AutoComplete from "antd/lib/auto-complete";
import { Rule } from "antd/lib/form";
import { NamePath } from "antd/lib/form/interface";

import { RVFormFloatingLabelWrap, RVHighlightedString } from "@regal-voice/ui";
import { HighlightSelect } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/Components/JourneyActionsPanel/NodeEditorPanel/Components/Shared/FormItemInputs/HighlightSelect";
import { caseInsensitiveFilter } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/Components/JourneyActionsPanel/NodeEditorPanel/shared";
import { OptionsData } from "ServerData/EventSchema/eventSchemaTypes";

export function EventNameSelect({
    value,
    onChange,
    label,
    placeholder,
    eventNames,
    name,
    hidden,
    dependencies,
    rules,
    allowCustomEventName,
}: {
    value?: any;
    onChange?: (evt: any) => void;
    label: string;
    placeholder?: string;
    eventNames: string[];
    name: NamePath;
    hidden?: boolean;
    dependencies?: NamePath[];
    rules?: Rule[];
    allowCustomEventName: boolean;
}): JSX.Element {
    function createEventNameValue(v: any, h?: string) {
        return { value: v, label: <RVHighlightedString val={v} highlightVal={h} /> };
    }
    function createEventNameOptionValues(values?: Array<any>, highlight?: string): OptionsData {
        return !!values ? values.map((v) => createEventNameValue(v, highlight)) : [];
    }
    return (
        <RVFormFloatingLabelWrap
            name={name}
            label={label}
            hidden={hidden}
            rules={rules}
            dependencies={dependencies}
            data-testid={`event-name-${name}`}
            noPadding
        >
            {allowCustomEventName ? (
                <AutoComplete
                    options={createEventNameOptionValues(eventNames)}
                    onChange={onChange}
                    filterOption={caseInsensitiveFilter}
                />
            ) : (
                <HighlightSelect value={value} onChange={onChange} options={eventNames} placeholder={placeholder} />
            )}
        </RVFormFloatingLabelWrap>
    );
}
